/* tslint:disable */
/* eslint-disable */
/**
 * ELEMENTS API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface BackendProperties
 */
export interface BackendProperties {
    /**
     * 
     * @type {boolean}
     * @memberof BackendProperties
     */
    supportsSharingRwPermissionsPriority: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof BackendProperties
     */
    supportsSharingAfp: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof BackendProperties
     */
    supportsSharingSmbRequireLogon: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof BackendProperties
     */
    supportsSharingSmbRecycleBin: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof BackendProperties
     */
    supportsSharingSmbXattrs: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof BackendProperties
     */
    supportsSharingSmbSymlinks: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof BackendProperties
     */
    supportsSharingSmbCustomOptions: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof BackendProperties
     */
    supportsSharingNfsPermissions: boolean;
}

export function BackendPropertiesFromJSON(json: any): BackendProperties {
    return BackendPropertiesFromJSONTyped(json, false);
}

export function BackendPropertiesFromJSONTyped(json: any, ignoreDiscriminator: boolean): BackendProperties {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'supportsSharingRwPermissionsPriority': json['supports_sharing_rw_permissions_priority'],
        'supportsSharingAfp': json['supports_sharing_afp'],
        'supportsSharingSmbRequireLogon': json['supports_sharing_smb_require_logon'],
        'supportsSharingSmbRecycleBin': json['supports_sharing_smb_recycle_bin'],
        'supportsSharingSmbXattrs': json['supports_sharing_smb_xattrs'],
        'supportsSharingSmbSymlinks': json['supports_sharing_smb_symlinks'],
        'supportsSharingSmbCustomOptions': json['supports_sharing_smb_custom_options'],
        'supportsSharingNfsPermissions': json['supports_sharing_nfs_permissions'],
    };
}

export function BackendPropertiesToJSON(value?: BackendProperties | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'supports_sharing_rw_permissions_priority': value.supportsSharingRwPermissionsPriority,
        'supports_sharing_afp': value.supportsSharingAfp,
        'supports_sharing_smb_require_logon': value.supportsSharingSmbRequireLogon,
        'supports_sharing_smb_recycle_bin': value.supportsSharingSmbRecycleBin,
        'supports_sharing_smb_xattrs': value.supportsSharingSmbXattrs,
        'supports_sharing_smb_symlinks': value.supportsSharingSmbSymlinks,
        'supports_sharing_smb_custom_options': value.supportsSharingSmbCustomOptions,
        'supports_sharing_nfs_permissions': value.supportsSharingNfsPermissions,
    };
}


